import { z } from 'zod';

export const collaborationSaveCode = z.enum([
  'map_content_size', 'map_encoded_size', 'map_state_size', 'data_layer_limit',
  'data_layers_subscription', 'service_area_subscription', 'invalid_document',
]);
export type CollaborationSaveCode = z.infer<typeof collaborationSaveCode>;

/** A rejected document needs a user correction, not a new connection. */
export class CollaborationSaveError extends Error {
  constructor(readonly code: CollaborationSaveCode, message: string = code) {
    super(message);
    this.name = 'CollaborationSaveError';
  }
}
